import { Injectable } from '@angular/core';
import {
    IOnboardingReportContainer,
    IOnboardingReportWidget,
} from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report';
import { FiOnboardingReportService } from '@fi-app/fi-onboarding/fi-onboarding-report/services/fi-onboarding-report.service';
import { FiOnboardingReportType } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-enums';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { Subject } from 'rxjs';

@Injectable()
export class FiOnboardingReportDataService {
    constructor(
        private fiOnboardingReportService: FiOnboardingReportService,
        private fiStateService: FiStateService,
        private fiCustomerDataService: FiCustomerDataService,
    ) {}

    private reportContainer: IOnboardingReportContainer;

    getReportContainer(): Promise<IOnboardingReportContainer> {
        return new Promise<IOnboardingReportContainer>((resolve, reject) => {
            if (this.reportContainer) {
                resolve(this.reportContainer);
            } else
                this.fiOnboardingReportService.getReportContainer().then((reportContainer) => {
                    this.reportContainer = reportContainer;

                    if (!this.fiCustomerDataService.isSynchronizedOnboardingEnabled()) {
                        this.reportContainer.Widgets = this.reportContainer.Widgets.filter(
                            (widget) =>
                                widget.ReportType !== FiOnboardingReportType.Synchronised &&
                                widget.ReportType !== FiOnboardingReportType.Independent,
                        );
                    }

                    resolve(this.reportContainer);
                }, reject);
        });
    }

    resetReportContainer(): void {
        this.reportContainer = undefined;
    }

    private _reportContainerUpdated$ = new Subject<void>();
    reportContainerUpdated$ = this._reportContainerUpdated$.asObservable();
    updateRecentActivityWidget(widget: IOnboardingReportWidget): void {
        this.reportContainer.Widgets = this.reportContainer.Widgets.map((w) => {
            if (w.Id === widget.Id) {
                return widget;
            }
            return w;
        });
        this._reportContainerUpdated$.next();
    }

    viewOnboardingReport(onboardingId: number) {
        this.getTotalOnboardingsReportWidgetId().then((widgetId) => {
            this.fiStateService.go(FiStateNames.Onboarding.Report.Widget.Locations._name, {
                id: widgetId,
                onboardingId: onboardingId,
            });
        });
    }

    private getTotalOnboardingsReportWidgetId(): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            this.getReportContainer().then((reportContainer) => {
                const totalOnboardingsReportWidget = reportContainer.Widgets.find(
                    (widget) => widget.ReportType === FiOnboardingReportType.Total,
                );
                if (totalOnboardingsReportWidget) {
                    resolve(totalOnboardingsReportWidget.Id);
                } else {
                    // no total onboardings report
                    reject();
                }
            });
        });
    }
}
